export const CUSTOMER_LANGUAGES = [
  { value: "en", label: "English" },
  { value: "nl", label: "Nederlands" },
  { value: "fr", label: "Français" },
  { value: "de", label: "Deutsch" },
];

export const REGION_FORMATTING_LOCALES = [
  { value: "nl-BE", label: "Nederlands (België)" },
  { value: "nl-NL", label: "Nederlands (Nederland)" },
  { value: "en-GB", label: "English (United Kingdom)" },
  { value: "en-US", label: "English (United States)" },
  { value: "fr-FR", label: "Français (France)" },
  { value: "de-DE", label: "Deutsch (Deutschland)" },
];

export const DEFAULT_LANGUAGE = "en";
export const DEFAULT_REGION_FORMATTING_LOCALE = "en-GB";

export const normalizeLanguage = (language) => {
  const value = String(language || DEFAULT_LANGUAGE).trim().toLowerCase().replace("_", "-").split("-")[0];
  return CUSTOMER_LANGUAGES.some((option) => option.value === value) ? value : DEFAULT_LANGUAGE;
};

export const normalizeRegionFormattingLocale = (locale) => {
  const value = String(locale || DEFAULT_REGION_FORMATTING_LOCALE).trim().replace("_", "-").toLowerCase();
  return REGION_FORMATTING_LOCALES.find((option) => option.value.toLowerCase() === value)?.value || DEFAULT_REGION_FORMATTING_LOCALE;
};

export const getIntlLocale = (language) => {
  const lang = (language || "en").toLowerCase();
  if (lang.startsWith("de")) return "de-DE";
  if (lang.startsWith("fr")) return "fr-FR";
  if (lang.startsWith("nl")) return "nl-NL";
  return "en-GB";
};
